import menuContext from 'pages/layout/components/MenuContext/context';

const MenuContextProvider = menuContext.Provider;
export default MenuContextProvider;
